__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "help-topic-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@bsd/auth-pkce-ui", "0.0.13", () => (Promise.all([__webpack_require__.e(980), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(55980))))));
			register("@bsd/service-agent-service-help-topic-api", "0.0.94", () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(26)]).then(() => (() => (__webpack_require__(20483))))));
			register("@bsd/ui-auth", "2.5.0", () => (Promise.all([__webpack_require__.e(329), __webpack_require__.e(898)]).then(() => (() => (__webpack_require__(6329))))));
			register("@bsd/ui-utils", "2.2.1", () => (Promise.all([__webpack_require__.e(354), __webpack_require__.e(227)]).then(() => (() => (__webpack_require__(9354))))));
			register("bxt-design-framework", "1.0.66", () => (Promise.all([__webpack_require__.e(97), __webpack_require__.e(746), __webpack_require__.e(475)]).then(() => (() => (__webpack_require__(59054))))));
			register("classnames", "2.3.1", () => (__webpack_require__.e(485).then(() => (() => (__webpack_require__(32485))))));
			register("date-fns", "2.28.0", () => (__webpack_require__.e(992).then(() => (() => (__webpack_require__(21992))))));
			register("js-cookie", "3.0.1", () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(18987))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-favicon", "2.0.7", () => (__webpack_require__.e(974).then(() => (() => (__webpack_require__(57974))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(89)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("uuid", "9.0.0", () => (__webpack_require__.e(308).then(() => (() => (__webpack_require__(79308))))));
			initExternal(79392);
			initExternal(31427);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};